<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Solicitudes Nacionales</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Funcionarios Frontera</li>
                  <li class="breadcrumb-item active">Tep</li>
                  <li class="breadcrumb-item active">Operaciones</li>
                  <li class="breadcrumb-item active">Solicitud Nacional</li>
                  <li class="breadcrumb-item active">Formulario</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row m-3">
                  <!-- Datos del Usuario -->
                  <div class="col-md-4">
                    <div class="card card-outline card-navy">
                      <div class="card-header pt-2 pb-2">
                        <h3 class="card-title">
                          <h6>
                            <i class="fas fa-users"></i>
                            Datos Usuario
                          </h6>
                        </h3>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="form-group col-md-12">
                            <label for="nombre">Nombre</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.nombre"
                              readonly
                            />
                          </div>
                          <div class="form-group col-md-12">
                            <label for="identificacion">Identificación</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.identificacion"
                              readonly
                            />
                          </div>
                          <div class="form-group col-md-12">
                            <label for="celular">Celular</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              v-model="form.celular"
                              readonly
                            />
                          </div>
                          <div class="form-group col-md-12">
                            <label for="area">Área</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.solicitante_area"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Datos del Transporte -->
                  <div class="col-md-4">
                    <div class="card card-outline card-navy">
                      <div class="card-header pt-2 pb-2">
                        <h3 class="card-title">
                          <h6>
                            <i class="fas fa-bus"></i>
                            Datos Transporte
                          </h6>
                        </h3>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="form-group col-md-12">
                            <label for="tipo_vehiculo">Tipo Vehículo</label>
                            <v-select
                              :class="[
                                $v.form.tipo_vehiculo.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="form.tipo_vehiculo"
                              placeholder="Tipo Vehiculo"
                              label="nombre"
                              :options="listasForms.tipo_vehiculos"
                              class="form-control form-control-sm p-0"
                              :disabled="data_CaPa"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-12">
                            <label for="fecha_ini">Fecha y Hora Inicial</label>
                            <div class="row ml-1">
                              <input
                                type="date"
                                v-model="form.fecha_ini"
                                style="font-size: 13px"
                                class="form-control form-control-sm col-md-6 mr-3"
                                :class="
                                  $v.form.fecha_ini.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="!disabledf && data_CaPa"
                              />
                              <input
                                v-model="form.hora_ini"
                                type="time"
                                class="form-control form-control-sm col-md-5"
                                style="font-size: 13px"
                                :class="
                                  $v.form.hora_ini.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="!disabledf && data_CaPa"
                                @blur="validaFechasForm"
                              />
                            </div>
                          </div>
                          <div class="form-group col-md-12">
                            <label for="fecha_fin">Fecha y Hora final</label>
                            <div class="row ml-1">
                              <input
                                type="date"
                                v-model="form.fecha_fin"
                                style="font-size: 13px"
                                class="form-control form-control-sm col-md-6 mr-3"
                                :class="
                                  $v.form.fecha_fin.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="!disabledf && data_CaPa"
                              />
                              <input
                                v-model="form.hora_fin"
                                type="time"
                                class="form-control form-control-sm col-md-5"
                                style="font-size: 13px"
                                :class="
                                  $v.form.hora_fin.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="!disabledf && data_CaPa"
                                @blur="validaFechasForm"
                              />
                            </div>
                          </div>
                          <div class="form-group col-md-12">
                            <label for="gerente_area"
                              >Nombre Gerente Área</label
                            >
                            <div class="row ml-1">
                              <v-select
                                :class="[
                                  $v.form.gerente_area.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid',
                                  $store.getters.getDarkMode
                                    ? 'dark-vselect'
                                    : '',
                                ]"
                                v-model="form.gerente_area"
                                placeholder="Gerente Area"
                                label="nombres"
                                :options="listasForms.gerente"
                                class="form-control form-control-sm p-0"
                                :disabled="data_CaPa"
                              ></v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Datos de la Locación -->
                  <div class="col-md-4">
                    <div class="card card-outline card-navy">
                      <div class="card-header pt-2 pb-2">
                        <h3 class="card-title">
                          <h6><i class="fas fa-street-view"></i> Locación</h6>
                        </h3>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="form-group col-md-12">
                            <label for="origen">Origen</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.direccionOrigen"
                              :class="
                                $v.form.direccionOrigen.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid'
                              "
                              :disabled="!disabledf && data_CaPa"
                            />
                          </div>
                          <div class="form-group col-md-12">
                            <label for="destino">Destino</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.direccionDestino"
                              :class="
                                $v.form.direccionDestino.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid'
                              "
                              :disabled="!disabledf && data_CaPa"
                            />
                          </div>
                          <div class="form-group col-md-12">
                            <label for="ruta_id">Ruta</label>
                            <v-select
                              v-model="ruta"
                              placeholder="Ruta"
                              label="nombre"
                              :options="listasForms.rutas"
                              class="form-control form-control-sm p-0"
                              :disabled="
                                (!disabledf && data_CaPa) || !form.pais_id
                              "
                              :class="[
                                $v.form.ruta_id.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              @input="seleccionarRuta()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-12">
                            <label for="motivo">Motivo</label>
                            <textarea
                              class="form-control form-control-sm"
                              v-model="form.motivo"
                              :disabled="!disabledf && data_CaPa"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Datos de los Pasajeros -->
                  <div class="col-md-12">
                    <div class="card card-outline card-navy">
                      <div class="card-header pt-2 pb-2">
                        <h3 class="card-title">
                          <h6>
                            <i class="fas fa-users"></i>
                            Datos Pasajeros
                          </h6>
                        </h3>
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="datos()"
                            :disabled="data_CaPa"
                          >
                            <i class="fas fa-child mr-1"></i>
                            <small>SOY YO</small>
                          </button>
                          <div class="card-tools">
                            <button
                              type="button"
                              class="btn btn-tool"
                              data-card-widget="collapse"
                              data-toggle="tooltip"
                              title="Collapse"
                            >
                              <i class="fas fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body pb-0" v-if="!data_CaPa">
                        <div
                          class="row"
                          v-if="
                            form.tipo_vehiculo &&
                              pasajeros.length <
                                form.tipo_vehiculo.cantidad_pasajeros
                          "
                        >
                          <div class="form-group col-md-2">
                            <label>N° Documento</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="formPa.numero_documento"
                              @change="getPasajero()"
                              :class="
                                $v.formPa.numero_documento.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid'
                              "
                              :disabled="data_CaPa"
                            />
                          </div>
                          <div class="form-group col-md-3">
                            <label>Nombre</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="formPa.nombre"
                              :class="
                                $v.formPa.nombre.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid'
                              "
                              :disabled="data_CaPa"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label>Teléfono</label>
                            <div>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                v-model="formPa.telefono"
                                :class="
                                  $v.formPa.telefono.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="data_CaPa"
                              />
                            </div>
                          </div>
                          <div class="form-group col-md-3">
                            <label>Email</label>
                            <input
                              type="email"
                              class="form-control form-control-sm"
                              v-model="formPa.correo"
                              :class="
                                $v.formPa.correo.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid'
                              "
                              :disabled="data_CaPa"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label>Empresa / Área</label>
                            <div>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="formPa.empresa"
                                :class="
                                  $v.formPa.empresa.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                :disabled="data_CaPa"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row justify-content-between">
                          <div class="form-group col-md-2">
                            <button
                              v-show="!$v.formPa.$invalid"
                              type="button"
                              @click="cargarPasajero()"
                              class="btn btn-sm btn-success text-nowrap col-md-12"
                              data-html="true"
                              title="Guardar Pasajero"
                            >
                              <i class="fa fa-plus mr-1"></i>
                              <small>Guardar Pasajero</small>
                            </button>
                          </div>
                          <div class="form-group text-center col-md-6">
                            <button
                              v-if="form.tipo_vehiculo && fileFormat"
                              type="button"
                              class="btn btn-sm bg-navy"
                              data-html="true"
                              title="Subir Lista"
                              @click="cargarPasajaeros"
                            >
                              <i class="fa fa-upload mr-1"></i>
                            </button>
                            <button
                              v-if="form.tipo_vehiculo && fileFormat"
                              type="button"
                              class="btn btn-sm bg-danger"
                              data-html="true"
                              title="Subir Lista"
                              @click="quitarLista"
                            >
                              <i class="fa fa-trash mr-1"></i>
                            </button>
                            <input
                              v-if="
                                form.tipo_vehiculo &&
                                  pasajeros.length <
                                    form.tipo_vehiculo.cantidad_pasajeros
                              "
                              ref="file_format"
                              type="file"
                              class="form-control-file btn btn-sm text-nowrap col-md-10"
                              accept=".xlsx"
                              @change="obtenerFile"
                            />
                            <span
                              v-if="
                                form.tipo_vehiculo &&
                                  pasajeros.length >=
                                    form.tipo_vehiculo.cantidad_pasajeros
                              "
                              class="badge badge-success float-center"
                              >El vehículo tipo
                              {{ form.tipo_vehiculo.nombre }} ya está
                              lleno.</span
                            >
                          </div>
                          <div class="form-group col-md-2">
                            <button
                              v-if="form.tipo_vehiculo"
                              id="formatoPasajeros"
                              type="button"
                              class="btn btn-sm bg-olive text-nowrap col-md-12"
                              data-html="true"
                              title="Guardar Pasajero"
                              @click="descargarFormatoPasajeros"
                            >
                              <i class="fa fa-file-excel mr-1"></i>
                              <small>Descargar Formato</small>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body" v-if="pasajeros.length > 0">
                        <div class="col-md-12 form-group">
                          <table
                            id="tabla-pasajeros"
                            class="table table-bordered table-striped table-hover table-sm"
                          >
                            <thead>
                              <tr>
                                <th class="text-center">Nombre</th>
                                <th class="text-center">N° Documento</th>
                                <th class="text-center">Email</th>
                                <th class="text-center">Teléfono</th>
                                <th class="text-center">Empresa</th>
                                <th class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(pasajero, index) in pasajeros"
                                :key="pasajero.id"
                              >
                                <td>
                                  <span
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <!-- Formulario para nombres -->
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      id="nombre"
                                      v-model="formPa2.nombre"
                                      :class="
                                        $v.formPa2.nombre.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </span>
                                  <span v-else>
                                    <!-- Dato nombre -->
                                    {{ pasajero.nombres }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <!-- Formulario para numero documento -->
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      id="numero_documento"
                                      v-model="formPa2.numero_documento"
                                      :class="
                                        $v.formPa2.numero_documento.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </span>
                                  <span v-else>
                                    <!-- Dato numero_documento -->
                                    {{ pasajero.numero_documento }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <!-- Formulario para correo -->
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      id="correo"
                                      v-model="formPa2.correo"
                                      :class="
                                        $v.formPa2.correo.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </span>
                                  <span v-else>
                                    <!-- Dato correo -->
                                    {{ pasajero.correo }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <!-- Formulario para telefono -->
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      id="telefono"
                                      v-model="formPa2.telefono"
                                      :class="
                                        $v.formPa2.telefono.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </span>
                                  <span v-else>
                                    <!-- Dato telefono -->
                                    {{ pasajero.telefono }}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <!-- Formulario para empresa -->
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      id="empresa"
                                      v-model="formPa2.empresa"
                                      :class="
                                        $v.formPa2.empresa.$invalid
                                          ? 'is-invalid'
                                          : 'is-valid'
                                      "
                                    />
                                  </span>
                                  <span v-else>
                                    <!-- Dato empresa -->
                                    {{ pasajero.empresa }}
                                  </span>
                                </td>
                                <td class="text-right">
                                  <div
                                    class="btn-group"
                                    v-if="
                                      formActualizarPa &&
                                        idActualizarPa == index
                                    "
                                  >
                                    <button
                                      v-show="!$v.formPa2.$invalid"
                                      type="button"
                                      class="btn btn-sm bg-success"
                                      @click="guardarActualizacionPa(index)"
                                      :disabled="data_CaPa"
                                    >
                                      <i class="fas fa-save"></i>
                                    </button>
                                  </div>
                                  <div class="btn-group" v-else>
                                    <!-- Botón para mostrar el formulario de actualizar -->
                                    <button
                                      type="button"
                                      class="btn btn-sm bg-navy"
                                      @click="verFormActualizarPa(index)"
                                      :disabled="data_CaPa"
                                    >
                                      <i class="fas fa-edit"></i>
                                    </button>
                                    <!-- Botón para borrar -->
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-danger"
                                      @click="borrarPasajero(index)"
                                      :disabled="data_CaPa"
                                    >
                                      <i class="fas fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Datos de los Ceco y Afe -->
                  <div class="col-md-12">
                    <div class="card card-outline card-navy">
                      <div class="card-header pt-2 pb-2">
                        <h3 class="card-title">
                          <h6>
                            <i class="fas fa-dollar-sign"></i> Datos Ceco y Afe
                          </h6>
                        </h3>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool"
                            data-card-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="form-group col-md-3">
                            <label for="pais_id">Pais</label>
                            <v-select
                              :class="[
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="pais"
                              placeholder="Paises"
                              label="nombre"
                              :options="listasForms.paises"
                              class="form-control form-control-sm p-0"
                              :disabled="data_CaPa"
                              @input="seleccionarPais()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="sociedad_presupuesto_id"
                              >Sociedad</label
                            >
                            <select
                              class="form-control form-control-sm"
                              v-model="formCeAf.sociedad_presupuesto_id"
                              :disabled="data_CaPa || !form.pais_id"
                              :class="[
                                claseValidacionFormCeAf(
                                  'sociedad_presupuesto_id',
                                  data_CaPa || !form.pais_id,
                                ),
                              ]"
                              @change="onSociedadMaestroChange()"
                            >
                              <option value="">Seleccione...</option>
                              <option
                                v-for="sociedad in listasForms.sociedades"
                                :key="sociedad.numeracion"
                                :value="sociedad.numeracion"
                              >
                                {{ sociedad.descripcion }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="activo_id">Activo</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="formCeAf.activo_id"
                              :disabled="
                                data_CaPa || !formCeAf.sociedad_presupuesto_id
                              "
                              :class="[
                                claseValidacionFormCeAf(
                                  'activo_id',
                                  data_CaPa ||
                                    !formCeAf.sociedad_presupuesto_id,
                                ),
                              ]"
                              @change="onActivoMaestroChange()"
                            >
                              <option value="">Seleccione...</option>
                              <option
                                v-for="activo in listasForms.activos"
                                :key="activo.numeracion"
                                :value="activo.numeracion"
                              >
                                {{ activo.descripcion }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="tipo_presupuesto"
                              >Tipo Presupuesto</label
                            >
                            <v-select
                              class="form-control form-control-sm p-0"
                              :class="[
                                claseValidacionFormCeAf(
                                  'tipo_presupuesto',
                                  data_CaPa || !formCeAf.activo_id,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="tipo_presupuesto"
                              placeholder="Tipo Presupuesto"
                              label="descripcion"
                              :options="listasForms.tipo_presupuesto"
                              :disabled="data_CaPa || !formCeAf.activo_id"
                              @input="selectTipoPresupuesto()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="bloque_id">Bloque</label>
                            <v-select
                              :class="[
                                claseValidacionForm(
                                  'bloque_id',
                                  data_CaPa || !formCeAf.tipo_presupuesto,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="bloque"
                              placeholder="Bloques"
                              label="nombre"
                              :options="listasForms.bloques"
                              class="form-control form-control-sm p-0"
                              :disabled="
                                data_CaPa || !formCeAf.tipo_presupuesto
                              "
                              @input="seleccionarBloque()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="area">Area</label>
                            <v-select
                              :class="[
                                claseValidacionForm(
                                  'area',
                                  data_CaPa || !form.bloque_id,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="area"
                              placeholder="Areas"
                              label="descripcion"
                              :options="listasForms.areas"
                              class="form-control form-control-sm p-0"
                              :disabled="data_CaPa || !form.bloque_id"
                              @input="seleccionarArea()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="sitio_id">Campo</label>
                            <v-select
                              class="form-control form-control-sm p-0"
                              v-model="sitio"
                              :disabled="data_CaPa || !form.area"
                              :class="[
                                claseValidacionForm(
                                  'sitio_id',
                                  data_CaPa || !form.area,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              placeholder="Seleccione Sitio..."
                              label="nombre"
                              :options="listasForms.sitios"
                              @input="selectSitio()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="numero">Código Contable</label>
                            <v-select
                              class="form-control form-control-sm p-0"
                              :class="[
                                claseValidacionFormCeAf(
                                  'cecos_afe_id',
                                  data_CaPa || !form.sitio_id,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="cecos"
                              placeholder="Código Contable"
                              label="codigo_contable"
                              :options="listasForms.lst_numero"
                              :disabled="data_CaPa || !form.sitio_id"
                              @input="selectNumeroContable()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-6">
                            <label for="responsable">Responsable</label>
                            <v-select
                              class="form-control form-control-sm p-0"
                              :class="[
                                claseValidacionFormCeAf(
                                  'responsable_id',
                                  data_CaPa || !formCeAf.numero,
                                ),
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              v-model="responsable"
                              placeholder="Responsable"
                              label="nombres"
                              :options="listasForms.respon"
                              :disabled="data_CaPa || !formCeAf.numero"
                              @input="getSelectResponsable()"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="porcentaje">Porcentaje</label>
                            <div class="input-group">
                              <input
                                class="form-control form-control-sm"
                                type="number"
                                min="0"
                                max="100"
                                v-model="formCeAf.porcentaje"
                                :class="
                                  claseValidacionFormCeAf(
                                    'porcentaje',
                                    data_CaPa,
                                  )
                                "
                                :disabled="data_CaPa"
                              />
                              <div class="input-group-append">
                                <span class="input-group-text form-control-sm"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-group mt-4 col-md-1">
                            <button
                              v-show="!$v.formCeAf.$invalid"
                              type="button"
                              @click="cargarCeco()"
                              class="btn btn-sm btn-success text-nowrap"
                              data-html="true"
                              data-toggle="tooltip"
                              :disabled="data_CaPa"
                            >
                              <i class="fa fa-plus"></i>
                              Guardar Ceco Afe
                            </button>
                          </div>
                          <div
                            class="col-md-12 mb-0 text-center"
                            :class="
                              total_porcentaje == 100
                                ? 'text-success'
                                : total_porcentaje < 100
                                ? 'text-muted'
                                : 'text-danger'
                            "
                          >
                            <h4>Porcentaje Total: {{ total_porcentaje }}%</h4>
                          </div>
                        </div>
                        <div class="col-md-12" v-if="cecosAfes.length > 0">
                          <div id="tabla pasajeros">
                            <div class="card-body p-0">
                              <div class="col-md-12 form-group">
                                <table
                                  id="tabla-pasajeros"
                                  class="table table-bordered table-striped table-hover table-sm"
                                >
                                  <thead>
                                    <tr>
                                      <th class="text-center">
                                        Tipo Presupuesto
                                      </th>
                                      <th
                                        class="text-center"
                                        v-if="metodo == 'POST'"
                                      >
                                        Sociedad
                                      </th>
                                      <th
                                        class="text-center"
                                        v-if="metodo == 'POST'"
                                      >
                                        Activo
                                      </th>
                                      <th class="text-center">Bloque</th>
                                      <th class="text-center">Área</th>
                                      <th
                                        class="text-center"
                                        v-if="metodo == 'POST'"
                                      >
                                        Campo
                                      </th>
                                      <th class="text-center">
                                        Número contable
                                      </th>
                                      <th class="text-center">Responsable</th>
                                      <th class="text-center">Porcentaje</th>
                                      <th class="text-center">Acciones</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template
                                      v-for="(cecoAfe, index) in cecosAfes"
                                    >
                                      <!-- Edición: mismas validaciones que el formulario principal (Ceco/Afe) -->
                                      <tr
                                        v-if="
                                          formActualizarCA &&
                                            idActualizarCA === index
                                        "
                                        :key="'ceco-edit-' + index"
                                      >
                                        <td colspan="11" class="p-3 bg-light">
                                          <div class="row">
                                            <div class="form-group col-md-3">
                                              <label>Sociedad</label>
                                              <select
                                                class="form-control form-control-sm"
                                                v-model="
                                                  formCeAf2.sociedad_presupuesto_id
                                                "
                                                :disabled="
                                                  data_CaPa || !form.pais_id
                                                "
                                                :class="[
                                                  $v.formCeAf2
                                                    .sociedad_presupuesto_id
                                                    .$invalid
                                                    ? 'is-invalid'
                                                    : 'is-valid',
                                                ]"
                                                @change="
                                                  onMaestroCecoCampoChangeEdit(
                                                    'sociedad',
                                                  )
                                                "
                                              >
                                                <option value="">
                                                  Seleccione...
                                                </option>
                                                <option
                                                  v-for="sociedad in listasForms.sociedades"
                                                  :key="sociedad.numeracion"
                                                  :value="sociedad.numeracion"
                                                >
                                                  {{ sociedad.descripcion }}
                                                </option>
                                              </select>
                                            </div>
                                            <div class="form-group col-md-3">
                                              <label>Activo</label>
                                              <select
                                                class="form-control form-control-sm"
                                                v-model="formCeAf2.activo_id"
                                                :disabled="
                                                  data_CaPa ||
                                                    !formCeAf2.sociedad_presupuesto_id
                                                "
                                                :class="[
                                                  $v.formCeAf2.activo_id
                                                    .$invalid
                                                    ? 'is-invalid'
                                                    : 'is-valid',
                                                ]"
                                                @change="
                                                  onMaestroCecoCampoChangeEdit(
                                                    'activo',
                                                  )
                                                "
                                              >
                                                <option value="">
                                                  Seleccione...
                                                </option>
                                                <option
                                                  v-for="activo in listasForms.activos"
                                                  :key="activo.numeracion"
                                                  :value="activo.numeracion"
                                                >
                                                  {{ activo.descripcion }}
                                                </option>
                                              </select>
                                            </div>
                                            <div class="form-group col-md-3">
                                              <label>Tipo Presupuesto</label>
                                              <v-select
                                                class="form-control form-control-sm p-0"
                                                :class="[
                                                  $v.formCeAf2.tipo_presupuesto
                                                    .$invalid
                                                    ? 'is-invalid'
                                                    : 'is-valid',
                                                  $store.getters.getDarkMode
                                                    ? 'dark-vselect'
                                                    : '',
                                                ]"
                                                v-model="tipo_presupuesto2"
                                                placeholder="Tipo Presupuesto"
                                                label="descripcion"
                                                :options="
                                                  listasForms.tipo_presupuesto
                                                "
                                                :disabled="
                                                  data_CaPa ||
                                                    !formCeAf2.activo_id
                                                "
                                                @input="
                                                  selectTipoPresupuesto2()
                                                "
                                              ></v-select>
                                            </div>
                                            <div class="form-group col-md-3">
                                              <label>Código Contable</label>
                                              <v-select
                                                class="form-control form-control-sm p-0"
                                                :class="[
                                                  $v.formCeAf2.cecos_afe_id
                                                    .$invalid
                                                    ? 'is-invalid'
                                                    : 'is-valid',
                                                  $store.getters.getDarkMode
                                                    ? 'dark-vselect'
                                                    : '',
                                                ]"
                                                v-model="cecos2"
                                                placeholder="Código Contable"
                                                label="codigo_contable"
                                                :options="
                                                  listasForms2.lst_numero
                                                "
                                                :disabled="
                                                  data_CaPa || !form.sitio_id
                                                "
                                                @input="selectNumeroContable2()"
                                              ></v-select>
                                            </div>
                                            <div class="form-group col-md-6">
                                              <label>Responsable</label>
                                              <v-select
                                                class="form-control form-control-sm p-0"
                                                :class="[
                                                  $v.formCeAf2.responsable_id
                                                    .$invalid
                                                    ? 'is-invalid'
                                                    : 'is-valid',
                                                  $store.getters.getDarkMode
                                                    ? 'dark-vselect'
                                                    : '',
                                                ]"
                                                v-model="responsable2"
                                                placeholder="Responsable"
                                                label="nombres"
                                                :options="listasForms2.respon"
                                                :disabled="data_CaPa"
                                                :readonly="!formCeAf2.numero"
                                                @input="getSelectResponsable2()"
                                              ></v-select>
                                            </div>
                                            <div class="form-group col-md-3">
                                              <label>Porcentaje</label>
                                              <div class="input-group">
                                                <input
                                                  class="form-control form-control-sm"
                                                  type="number"
                                                  min="0"
                                                  max="100"
                                                  v-model="formCeAf2.porcentaje"
                                                  :class="
                                                    $v.formCeAf2.porcentaje
                                                      .$invalid
                                                      ? 'is-invalid'
                                                      : 'is-valid'
                                                  "
                                                  :disabled="data_CaPa"
                                                />
                                                <div class="input-group-append">
                                                  <span
                                                    class="input-group-text form-control-sm"
                                                    >%</span
                                                  >
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="form-group mt-4 col-md-2 d-flex align-items-end"
                                            >
                                              <button
                                                v-show="!$v.formCeAf2.$invalid"
                                                type="button"
                                                class="btn btn-sm bg-success"
                                                @click="
                                                  guardarActualizacionCecoAfe(
                                                    index,
                                                  )
                                                "
                                                :disabled="data_CaPa"
                                              >
                                                <i class="fas fa-save"></i>
                                                Guardar
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr v-else :key="'ceco-view-' + index">
                                        <td class="text-center">
                                          <span
                                            class="badge"
                                            :class="
                                              cecoAfe.tipo_presupuesto
                                                .numeracion == 1 ||
                                              cecoAfe.tipo_presupuesto == 1
                                                ? 'bg-info'
                                                : cecoAfe.tipo_presupuesto
                                                    .numeracion == 2 ||
                                                  cecoAfe.tipo_presupuesto == 2
                                                ? 'bg-navy'
                                                : 'bg-lime'
                                            "
                                            >{{
                                              cecoAfe.nTipoPresupuesto
                                            }}</span
                                          >
                                        </td>
                                        <td
                                          class="text-center small"
                                          v-if="metodo == 'POST'"
                                        >
                                          {{ cecoAfe.nSociedad || "—" }}
                                        </td>
                                        <td
                                          class="text-center small"
                                          v-if="metodo == 'POST'"
                                        >
                                          {{ cecoAfe.nActivo || "—" }}
                                        </td>
                                        <td class="text-center small">
                                          {{ etiquetaUbicacionBloqueCeco }}
                                        </td>
                                        <td class="text-center small">
                                          {{ etiquetaUbicacionAreaCeco }}
                                        </td>
                                        <td
                                          class="text-center small"
                                          v-if="metodo == 'POST'"
                                        >
                                          {{ etiquetaUbicacionCampoCeco }}
                                        </td>
                                        <td class="text-center">
                                          {{
                                            cecoAfe.numero &&
                                            typeof cecoAfe.numero === "object"
                                              ? cecoAfe.numero.id
                                              : cecoAfe.numero || "—"
                                          }}
                                        </td>
                                        <td>
                                          {{ cecoAfe.nombre_responsable }}
                                        </td>
                                        <td class="text-right">
                                          {{ cecoAfe.porcentaje }}%
                                        </td>
                                        <td class="text-right">
                                          <div class="btn-group">
                                            <button
                                              type="button"
                                              class="btn btn-sm bg-navy"
                                              @click="
                                                verFormActualizarCecoAfe(index)
                                              "
                                              :disabled="
                                                (formActualizarCA &&
                                                  idActualizarCA != index) ||
                                                  data_CaPa
                                              "
                                            >
                                              <i class="fas fa-edit"></i>
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-sm btn-danger"
                                              @click="borrarCecoAfe(index)"
                                              :disabled="
                                                (formActualizarCA &&
                                                  idActualizarCA != index) ||
                                                  data_CaPa
                                              "
                                            >
                                              <i class="fas fa-trash-alt"></i>
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button
                  class="btn bg-primary col-md-1"
                  @click="save()"
                  v-if="
                    !$v.form.$invalid &&
                      this.pasajeros.length > 0 &&
                      this.total_porcentaje == 100 &&
                      ($store.getters.can(
                        'funcionariofrontera.solicitudNacional.create',
                      ) ||
                        $store.getters.can(
                          'funcionariofrontera.solicitudNacional.edit',
                        ))
                  "
                  :disabled="!disabledf && data_CaPa"
                >
                  <i class="fas fa-paper-plane"></i><br />Guardar
                </button>
                <button class="btn bg-secondary col-md-1" @click="back()">
                  <i class="fas fa-reply"></i><br />Volver
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import {
  required,
  email,
  maxLength,
  minValue,
  maxValue,
  regex,
} from "vuelidate/lib/validators";
import vSelect from "vue-select";
import moment from "moment";

export default {
  name: "FuncionarioSolicitudNacionalesForm",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      data_CaPa: this.$route.params.accion == "Editar",
      total_porcentaje: 0,
      disabledf: false,
      responsable: null,
      cecosAfes: [],
      tipo_vehiculo: [],
      formActualizarCA: false,
      idActualizarCA: -1,
      fileFormat: null,
      formActualizarPa: false,
      idActualizarPa: -1,
      pasajeros: [],
      bloque: {},
      ruta: {},
      pais: {},
      area: {},
      sitio: {},
      cecos: {},
      responsables: [],
      tipo_presupuesto: {},
      tipo_presupuesto2: {},
      cecos2: {},
      responsable2: {},
      formCeAf: {
        responsable_id: null,
        nombre_responsable: null,
        tipo_presupuesto: null,
        porcentaje: null,
        numero: null,
        cecos_afe_id: null,
        sociedad_presupuesto_id: null,
        activo_id: null,
      },
      formCeAf2: {
        responsable_id: null,
        nombre_responsable: null,
        tipo_presupuesto: null,
        porcentaje: null,
        numero: null,
        cecos_afe_id: null,
        sociedad_presupuesto_id: null,
        activo_id: null,
      },
      formPa: {
        nombre: null,
        numero_documento: null,
        correo: null,
        telefono: null,
        empresa: null,
      },
      formPa2: {
        nombre: null,
        numero_documento: null,
        correo: null,
        telefono: null,
        empresa: null,
      },
      form: {
        nombre: "",
        identificacion: null,
        celular: null,
        solicitante_area: null,
        area: null,
        bloque_id: null,
        pais_id: null,
        tipo_vehiculo: null,
        fecha_ini: null,
        hora_ini: null,
        fecha_fin: null,
        hora_fin: null,
        gerente_area: null,
        sitio_id: null,
        direccionOrigen: null,
        direccionDestino: null,
        ruta_id: null,
        ruta: null,
        metodo: null,
      },
      form1: {},
      user: [],
      pasajero: [],
      metodo: "",
      listasForms: {
        tipo_vehiculos: [],
        gerente: [],
        ciudades: [],
        geocercas_zonas: [],
        respon: [],
        lst_numero: [],
        tipo_presupuesto: [],
        tipo_presupuesto_list: [],
        bloques: [],
        bloques_list: [],
        paises: [],
        areas: [],
        areas_list: [],
        sociedades: [],
        sociedades_list: [],
        activos: [],
        activos_list: [],
        sitios: [],
        sitios_list: [],
      },
      listasForms2: {
        lst_numero: [],
        respon: [],
      },
      uri_docs: process.env.VUE_APP_API_URL,
      cargando: false,
    };
  },
  computed: {
    etiquetaUbicacionBloqueCeco() {
      return (this.bloque && this.bloque.nombre) || "—";
    },
    etiquetaUbicacionAreaCeco() {
      return (this.area && this.area.descripcion) || "—";
    },
    etiquetaUbicacionCampoCeco() {
      if (!this.sitio) {
        return "—";
      }
      return this.sitio.nombre || this.sitio.descripcion || "—";
    },
  },
  validations: {
    form: {
      tipo_vehiculo: {
        required,
      },
      fecha_ini: {
        required,
        validFormat: (value) =>
          /^(?:\d{4})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$/.test(
            value,
          ),
      },
      hora_ini: {
        required,
      },
      fecha_fin: {
        required,
        validFormat: (value) =>
          /^(?:\d{4})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$/.test(
            value,
          ),
      },
      hora_fin: {
        required,
      },
      gerente_area: {
        required,
      },
      direccionOrigen: {
        required,
      },
      direccionDestino: {
        required,
      },
      ruta_id: {
        required,
      },
      /* bloque_id: {
        required,
      },
      pais_id: {
        required,
      },
      area: {
        required,
      },
      sitio_id: {
        required,
      }, */
    },

    formCeAf: {
      responsable_id: {
        required,
      },
      tipo_presupuesto: {
        required,
      },
      porcentaje: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(100),
      },
      cecos_afe_id: {
        required,
      },
      activo_id: {
        required,
      },
      sociedad_presupuesto_id: {
        required,
      },
    },

    formCeAf2: {
      responsable_id: {
        required,
      },
      tipo_presupuesto: {
        required,
      },
      porcentaje: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(100),
      },
      cecos_afe_id: {
        required,
      },
      activo_id: {
        required,
      },
      sociedad_presupuesto_id: {
        required,
      },
    },

    formPa: {
      nombre: {
        required,
      },
      numero_documento: {
        required,
      },
      correo: {
        required,
        email,
      },
      telefono: {
        required,
        maxLength: maxLength(10),
      },
      empresa: {
        required,
      },
    },

    formPa2: {
      nombre: {
        required,
      },
      numero_documento: {
        required,
      },
      correo: {
        required,
      },
      telefono: {
        required,
      },
      empresa: {
        required,
      },
    },
  },

  methods: {
    claseValidacionFormCeAf(campo, deshabilitado) {
      if (this.data_CaPa || deshabilitado) {
        return "";
      }
      const ref = this.$v.formCeAf[campo];
      if (!ref) {
        return "";
      }
      return ref.$invalid ? "is-invalid" : "is-valid";
    },

    claseValidacionForm(campo, deshabilitado) {
      if (this.data_CaPa || deshabilitado) {
        return "";
      }
      const ref = this.$v.form[campo];
      if (!ref) {
        return "";
      }
      return ref.$invalid ? "is-invalid" : "is-valid";
    },

    async init() {
      this.cargando = true;
      if (this.$route.params.accion == "Editar") {
        this.metodo = "PUT";
        this.form1 = this.$route.params.data_edit;

        this.pais = {
          id: this.form1.pais.id,
          nombre: this.form1.pais.nombre,
        };
        this.ruta = {
          id: this.form1.ruta_tep.id,
          nombre: this.form1.ruta_tep.nombre,
          pais_id: this.form1.ruta_tep.pais_id,
        };
        this.bloque = {
          id: this.form1.bloque.id,
          nombre: this.form1.bloque.nombre,
          pais_id: this.form1.bloque.pais_id,
        };

        this.area = this.listasForms.areas_list.find(
          (area) => area.numeracion == this.form1.area,
        );

        this.form.pais_id = this.form1.pais_id;
        this.form.bloque_id = this.form1.bloque_id;
        this.form.ruta_id = this.form1.ruta_id;
        this.form.area = this.form1.area;
        this.form.user_id = this.form1.user.id;
        this.form.nombre = this.form1.user.name;
        this.form.identificacion = this.form1.user.n_document;
        this.form.celular = this.form1.user.cel;
        this.form.solicitante_area = this.form1.user.funcionario[0]
          ? this.form1.user.funcionario[0].nArea
          : null;
        this.form.id = this.form1.id;
        this.form.tipo_operacion = this.form1.tipo_operacion;
        this.form.sitio = this.form1.sitio;
        if (this.form1.sitio && this.form1.sitio.id) {
          this.sitio = this.form1.sitio;
          this.form.sitio_id = this.form1.sitio.id;
        }
        this.form.tipo_vehiculo = {
          id: this.form1.tipo_vehiculo.id,
          nombre: this.form1.tipo_vehiculo.nombre,
          cantidad_pasajeros: this.form1.tipo_vehiculo.cantidad_pasajeros,
        };
        this.form.fecha_ini = this.form1.fecha_hora_inicio_servicio.slice(
          0,
          10,
        );
        this.form.hora_ini = this.form1.fecha_hora_inicio_servicio.slice(
          11,
          19,
        );
        this.form.fecha_fin = this.form1.fecha_hora_fin_servicio.slice(0, 10);
        this.form.hora_fin = this.form1.fecha_hora_fin_servicio.slice(11, 19);

        this.form.direccionOrigen = this.form1.direccion_origen;
        this.form.direccionDestino = this.form1.direccion_destino;
        this.form.ruta = this.form1.ruta;
        this.form.motivo = this.form1.motivo;

        this.form.gerente_area = {};
        if (this.form1.funcionario_gerente) {
          this.form.gerente_area = {
            id: this.form1.funcionario_gerente.id,
            nombres:
              this.form1.funcionario_gerente.nombres +
              " " +
              this.form1.funcionario_gerente.apellidos,
            user_id: this.form1.funcionario_gerente.user_id,
          };
        }

        await this.llenarcecoAfe();
        this.llenarpasajero();
        this.cambioFecha();

        await this.getUser();
        this.cargando = false;
      } else {
        this.metodo = "POST";
        await this.getUser();
        this.cargando = false;
      }
    },

    back() {
      return this.$router.replace("/FuncionariosGeopark/solicitudNacional");
    },

    porcentajeTotal() {
      if (this.formCeAf.porcentaje) {
        this.total_porcentaje += Number(this.formCeAf.porcentaje);
        // Se valida el total del porcentaje si es mayor a 100%
        if (this.total_porcentaje > 100) {
          this.$swal({
            title: "Excedio la cantidad de ceco y afe permitida",
            text: `El limite del porcentaje es 100% de Ceco o Afe, por favor validar..`,
            icon: "warning",
            showConfirmButton: false,
            timer: 2000,
            backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
          });
          this.total_porcentaje -= Number(this.formCeAf.porcentaje);
          this.cecosAfes.pop();
        }
      }
    },

    cantPasajeros() {
      // Se valida la cantidad de pasajero dependiendo el tipo de vehiculo
      if (this.pasajeros.length > this.form.tipo_vehiculo.cantidad_pasajeros) {
        this.$swal({
          title: "Excedio la cantidad de pasajeros permitida",
          text:
            "La cantidad máxima de pasajeros para el tipo de vehiculo " +
            " " +
            this.form.tipo_vehiculo.nombre +
            " " +
            "son" +
            " " +
            " " +
            this.form.tipo_vehiculo.cantidad_pasajeros,
          icon: "warning",
          showConfirmButton: false,
          timer: 2000,
          backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
        });
        this.pasajeros.pop();
      }
    },

    llenarcecoAfe() {
      let datos = {};
      let porcentaje = 0;
      for (let c = 0; c < this.form1.ceco_afe.length; c++) {
        porcentaje += Number(this.form1.ceco_afe[c].porcentaje);
        const row = this.form1.ceco_afe[c];
        const sociedad = (this.listasForms.sociedades_list || []).find(
          (s) => s.numeracion == row.sociedad_presupuesto_id,
        );
        const activo = (this.listasForms.activos_list || []).find(
          (a) => a.numeracion == row.activo_id,
        );

        datos = {
          responsable: row.funcionario,
          responsable_id:
            row.responsable_id || (row.funcionario && row.funcionario.id),
          nombre_responsable:
            row.nombre_responsable ||
            (row.funcionario &&
              `${row.funcionario.nombres || ""} ${row.funcionario.apellidos ||
                ""}`.trim()),
          tipo_presupuesto: row.tipo_presupuesto,
          nTipoPresupuesto: row.nTipoPresupuesto,
          numero: row.numero.codigo_contable,
          porcentaje: row.porcentaje,
          id: row.id,
          cecos_afe_id:
            row.cecos_afe_id ||
            (row.numero && typeof row.numero === "object"
              ? row.numero.id
              : null),
          sociedad_presupuesto_id: row.sociedad_presupuesto_id,
          activo_id: row.activo_id,
          nSociedad: sociedad ? sociedad.descripcion : "—",
          nActivo: activo ? activo.descripcion : "—",
        };
        this.cecosAfes.push(datos);
      }
      this.total_porcentaje = porcentaje;
    },

    llenarpasajero() {
      let datos = {};

      for (let z = 0; z < this.form1.pasajeros.length; z++) {
        datos = {
          nombres: this.form1.pasajeros[z].nombres,
          numero_documento: this.form1.pasajeros[z].numero_documento,
          telefono: this.form1.pasajeros[z].telefono,
          correo: this.form1.pasajeros[z].correo,
          empresa: this.form1.pasajeros[z].empresa_id,
          id: this.form1.pasajeros[z].id,
        };

        this.pasajeros.push(datos);
      }
    },

    getTipoVehiculo() {
      let me = this;
      var url = "api/admin/tiposVehiculos/lista";
      axios
        .get(url, {
          params: {
            linea_negocio_id: 5,
          },
        })
        .then(function(response) {
          let respuesta = response.data;
          me.listasForms.tipo_vehiculos = respuesta;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getRutas() {
      let me = this;
      var url = "api/tep/Ruta/lista";
      axios
        .get(url, {
          params: {
            pais_id: this.form.pais_id,
          },
        })
        .then(function(response) {
          let respuesta = response.data;
          me.listasForms.rutas = respuesta;
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getBloques() {
      axios
        .get("/api/tep/bloques/lista", {
          params: {
            pais_id: this.form.pais_id,
          },
        })
        .then((response) => {
          const data = response.data || [];
          this.listasForms.bloques_list = data;
          if (
            !this.listasForms.bloques ||
            this.listasForms.bloques.length === 0
          ) {
            this.listasForms.bloques = data;
          }
        });
    },

    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },

    getSociedades() {
      axios.get("/api/lista/229").then((response) => {
        this.listasForms.sociedades_list = response.data;
      });
    },

    getActivos() {
      axios.get("/api/lista/230").then((response) => {
        this.listasForms.activos_list = response.data;
      });
    },

    async getSitios() {
      await axios.get("/api/tep/sitios/lista").then((response) => {
        const data = response.data || [];
        this.listasForms.sitios_list = data;
      });
    },

    async getAreas() {
      await axios.get("/api/lista/78").then((response) => {
        const data = response.data || [];
        this.listasForms.areas_list = data;
        this.listasForms.areas = data;
      });
    },

    seleccionarBloque() {
      this.form.bloque_id = null;
      if (!this.bloque || !this.bloque.id) {
        this.limpiarDesdeNivelMaestroCeco("bloque");
        return;
      }
      this.form.bloque_id = this.bloque.id;
      this.getNumeroContable();
    },

    seleccionarSitio() {
      this.form.sitio_id = null;
      if (this.sitio) {
        this.form.sitio_id = this.sitio.id;
      }
    },

    seleccionarRuta() {
      this.form.ruta_id = null;
      if (this.ruta) {
        this.form.ruta_id = this.ruta.id;
        this.form.ruta_nombre = this.ruta.nombre;
      }
    },

    seleccionarPais() {
      if (!this.pais || !this.pais.id) {
        this.form.pais_id = null;
        this.limpiarDesdeNivelMaestroCeco("pais");
        return;
      }
      this.form.pais_id = this.pais.id;
      this.limpiarDesdeNivelMaestroCeco("sociedad");
      this.getBloques();
      this.getRutas();
      this.getResponsable();
    },

    seleccionarArea() {
      this.form.area = null;
      if (!this.area || this.area.numeracion == null) {
        this.limpiarDesdeNivelMaestroCeco("area");
        return;
      }
      this.form.area = this.area.numeracion;
      this.getNumeroContable();
    },

    onSociedadMaestroChange() {
      const v = this.formCeAf.sociedad_presupuesto_id;
      if (v === "" || v === null || v === undefined) {
        this.limpiarDesdeNivelMaestroCeco("sociedad");
        return;
      }
      this.limpiarDesdeNivelMaestroCeco("activo");
    },

    onActivoMaestroChange() {
      const v = this.formCeAf.activo_id;
      if (v === "" || v === null || v === undefined) {
        this.limpiarDesdeNivelMaestroCeco("activo");
        return;
      }
      this.limpiarDesdeNivelMaestroCeco("tipo_presupuesto");
    },

    limpiarDesdeNivelMaestroCeco(nivel, opciones = {}) {
      const refrescarListaCecos = opciones.refrescarListaCecos !== false;

      const codigoAbajo = () => {
        this.cecos = {};
        this.responsable = null;
        this.formCeAf.cecos_afe_id = null;
        this.formCeAf.numero = null;
        this.formCeAf.responsable_id = null;
        this.formCeAf.nombre_responsable = null;
        this.formCeAf.porcentaje = null;
        this.listasForms.lst_numero = [];
        /* No vaciar listasForms.respon: es la lista global de funcionarios (getResponsable)
           y getNumeroContable no la repone; si se vacía, el v-select Responsable queda sin opciones. */
      };

      const sitioAbajo = () => {
        this.sitio = {};
        this.form.sitio_id = null;
        this.listasForms.sitios = [];
        codigoAbajo();
      };

      const areaAbajo = () => {
        this.area = {};
        this.form.area = null;
        this.listasForms.areas = [];
        sitioAbajo();
      };

      const bloqueAbajo = () => {
        this.bloque = {};
        this.form.bloque_id = null;
        this.listasForms.bloques = [];
        areaAbajo();
      };

      const tipoAbajo = () => {
        this.tipo_presupuesto = {};
        this.formCeAf.tipo_presupuesto = null;
        this.listasForms.tipo_presupuesto = [];
        bloqueAbajo();
      };

      const activoAbajo = () => {
        this.formCeAf.activo_id = null;
        this.listasForms.activos = [];
        tipoAbajo();
      };

      const sociedadAbajo = () => {
        this.formCeAf.sociedad_presupuesto_id = null;
        this.listasForms.sociedades = [];
        activoAbajo();
      };

      const paisAbajo = () => {
        this.form.pais_id = null;
        this.pais = {};
        this.ruta = {};
        this.form.ruta_id = null;
        this.listasForms.rutas = [];
        this.bloque = {};
        this.form.bloque_id = null;
        this.listasForms.bloques = [];
        this.listasForms.bloques_list = [];
        sociedadAbajo();
      };

      switch (nivel) {
        case "pais":
          paisAbajo();
          break;
        case "sociedad":
          sociedadAbajo();
          break;
        case "activo":
          activoAbajo();
          break;
        case "tipo_presupuesto":
          tipoAbajo();
          break;
        case "bloque":
          bloqueAbajo();
          break;
        case "area":
          areaAbajo();
          break;
        case "sitio":
          sitioAbajo();
          break;
        default:
          break;
      }

      if (refrescarListaCecos) {
        this.getNumeroContable();
      }
      if (!this.listasForms.respon || this.listasForms.respon.length === 0) {
        this.getResponsable();
      }
    },

    async getGerente() {
      axios
        .get("/api/admin/funcionarios/lista", {
          params: {
            gerente_area: 1,
          },
        })
        .then((response) => {
          this.listasForms.gerente = response.data;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getTipoPresupuesto() {
      this.listasForms.tipo_presupuesto_list = [];
      axios.get("/api/lista/151").then((response) => {
        this.listasForms.tipo_presupuesto_list = response.data;
      });
    },

    normalizarListaCecosYafes(payload) {
      return Array.isArray(payload) ? payload : [];
    },

    etiquetasContextoMaestroCeco(formCeAfParcial) {
      return {
        ...this.etiquetasCecoSociedadActivo(formCeAfParcial),
        nBloque: this.bloque && this.bloque.nombre ? this.bloque.nombre : "—",
        nArea: this.area && this.area.descripcion ? this.area.descripcion : "—",
        nCampo:
          this.sitio && (this.sitio.nombre || this.sitio.descripcion)
            ? this.sitio.nombre || this.sitio.descripcion
            : "—",
      };
    },

    etiquetasCecoSociedadActivo(formCeAfParcial) {
      const ce = formCeAfParcial || this.formCeAf;
      const sociedad = (this.listasForms.sociedades_list || []).find(
        (s) => s.numeracion == ce.sociedad_presupuesto_id,
      );
      const activo = (this.listasForms.activos_list || []).find(
        (a) => a.numeracion == ce.activo_id,
      );
      return {
        nSociedad: sociedad ? sociedad.descripcion : "—",
        nActivo: activo ? activo.descripcion : "—",
      };
    },

    padresCecoFormulario() {
      return {
        pais_id: this.form.pais_id,
        bloque_id: this.form.bloque_id,
        area: this.form.area,
        sitio_id: this.form.sitio_id,
      };
    },

    cecosAfesConPadresParaApi() {
      const padres = this.padresCecoFormulario();
      return this.cecosAfes.map((fila) => ({
        ...fila,
        ...padres,
      }));
    },

    obtenerIdsUnicos(lista, key) {
      const ids = new Set();
      for (const item of lista) {
        const v = item ? item[key] : null;
        if (v !== null && v !== undefined && v !== "") ids.add(v);
      }
      return ids;
    },

    filtrarListaPorIds(listaMaestra, ids, key = "numeracion") {
      const base = Array.isArray(listaMaestra) ? listaMaestra : [];
      return base.filter((x) => ids.has(x[key]));
    },

    segmentarCecosAfes(cecosYafes) {
      const sociedadesNum = this.obtenerIdsUnicos(
        cecosYafes,
        "sociedad_presupuesto_id",
      );
      const activosNum = this.obtenerIdsUnicos(cecosYafes, "activo_id");

      const tipoPresupuestoNum = this.obtenerIdsUnicos(
        cecosYafes,
        "tipo_presupuesto",
      );

      const bloqueNum = this.obtenerIdsUnicos(cecosYafes, "bloque_id");
      const areaNum = this.obtenerIdsUnicos(cecosYafes, "area");
      const sitioNum = this.obtenerIdsUnicos(cecosYafes, "sitio_id");

      const socF = this.filtrarListaPorIds(
        this.listasForms.sociedades_list,
        sociedadesNum,
      );
      const actF = this.filtrarListaPorIds(
        this.listasForms.activos_list,
        activosNum,
      );
      const tipoF = this.filtrarListaPorIds(
        this.listasForms.tipo_presupuesto_list,
        tipoPresupuestoNum,
      );
      const bloqF = this.filtrarListaPorIds(
        this.listasForms.bloques_list,
        bloqueNum,
        "id",
      );
      const areaF = this.filtrarListaPorIds(
        this.listasForms.areas_list,
        areaNum,
        "numeracion",
      );
      const sitF = this.filtrarListaPorIds(
        this.listasForms.sitios_list,
        sitioNum,
        "id",
      );

      /* Si la API no trae bloque/área/sitio en cada fila, el filtro queda vacío y los
         desplegables se vaciaban: se usa la lista maestra completa como respaldo. */
      this.listasForms.sociedades =
        socF.length > 0 ? socF : this.listasForms.sociedades_list || [];
      this.listasForms.activos =
        actF.length > 0 ? actF : this.listasForms.activos_list || [];
      this.listasForms.tipo_presupuesto =
        tipoF.length > 0 ? tipoF : this.listasForms.tipo_presupuesto_list || [];
      this.listasForms.bloques =
        bloqF.length > 0 ? bloqF : this.listasForms.bloques_list || [];
      this.listasForms.areas =
        areaF.length > 0 ? areaF : this.listasForms.areas_list || [];
      this.listasForms.sitios =
        sitF.length > 0 ? sitF : this.listasForms.sitios_list || [];
    },

    getNumeroContable() {
      let filtros = {
        area: this.form.area ? this.form.area : null,
        sitio_id: this.form.sitio_id ? this.form.sitio_id : null,
        bloque_id: this.form.bloque_id ? this.form.bloque_id : null,
        pais_id: this.form.pais_id ? this.form.pais_id : null,
        tipo_presupuesto: this.formCeAf.tipo_presupuesto
          ? this.formCeAf.tipo_presupuesto
          : null,
        activo_id: this.formCeAf.activo_id ? this.formCeAf.activo_id : null,
        sociedad_presupuesto_id: this.formCeAf.sociedad_presupuesto_id
          ? this.formCeAf.sociedad_presupuesto_id
          : null,
      };
      axios
        .get("/api/admin/cecosYafes/lista", {
          params: filtros,
        })
        .then((response) => {
          const data = this.normalizarListaCecosYafes(response.data);
          this.segmentarCecosAfes(data);
          this.listasForms.lst_numero = data;
        });
    },

    getResponsable() {
      // Se filtra que el funcionario tenga un usuario asignado
      axios
        .get("/api/admin/funcionarios/lista", {
          params: { con_usuario: 1 },
        })
        .then((response) => {
          this.listasForms.respon = response.data;
        });
    },

    async getUser() {
      await axios.get("/api/funcionariosFrontera/getUser").then((response) => {
        this.user = response.data[0];
      });
      this.form.user_id = this.user.id;
      this.form.nombre = this.user.name;
      this.form.identificacion = this.user.n_document;
      this.form.celular = this.user.cel;
      this.form.solicitante_area = this.user.funcionario[0]
        ? this.user.funcionario[0].nArea
        : null;
    },

    getPasajero() {
      axios
        .get("/api/funcionariosFrontera/getPasajero", {
          params: {
            numero_documento: this.formPa.numero_documento,
          },
        })
        .then((response) => {
          let pasajero = response.data;

          if (pasajero) {
            this.formPa.funcionario_id = pasajero.id;
            let nombres = pasajero.nombres ? pasajero.nombres : "";
            let apellidos = pasajero.apellidos ? pasajero.apellidos : "";
            this.formPa.nombre = nombres + " " + apellidos;

            this.formPa.correo = pasajero.email;
            this.formPa.telefono = pasajero.celular_principal;
            this.formPa.empresa = pasajero.nArea;
          }
        });
    },

    validaFechasForm() {
      if (this.form.fecha_ini && this.form.fecha_fin) {
        const fecha_menor = new Date(this.form.fecha_ini);
        const fecha_mayor = new Date(this.form.fecha_fin);

        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.form.fecha_fin = null;
          this.form.hora_fin = null;
          this.$swal({
            icon: "error",
            title: `La fecha final no puede ser menor a la fecha inicial..`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form.fecha_ini && this.form.hora_ini) {
        let fecha_actual = moment().format("YYYY-MM-DD");
        let hora_actual = moment().format("HH:mm:ss");
        let actual = moment(fecha_actual + " " + hora_actual);
        let fecha_soli = moment(this.form.fecha_ini + " " + this.form.hora_ini);
        let diff = fecha_soli.diff(actual, "m");

        if (diff < 720) {
          //this.form.fecha_ini = null;
          //this.form.hora_ini = null;
          //this.form.fecha_fin = null;
          //this.form.hora_fin = null;
          this.$swal({
            icon: "info",
            html: `Estimado Usuario, Su solicitud no cumple las 12 horas de anticipación al inicio del servicio, tiempo requerido para realizar una correcta coordinación, inspección y postulación de vehículo y conductor. Si su servicio es de carácter urgente, requerimos que su Gerente nos de la aprobación por medio de correo electrónico para gestionar el requerimiento como emergente.`,
            confirmButtonText: "Aceptar",
            timerProgressBar: true,
          });
        }
      }
      if (this.form.hora_fin) {
        if (this.form.hora_fin >= "20:00:00") {
          this.$swal({
            text:
              "Tenga en cuenta que el recorrido del vehiculo va hasta las 20:00.!!",
            icon: "info",
            confirmButtonText: "Aceptar!",
          });
        }
      }
    },

    cambioFecha() {
      let hoy = moment()
        .add(-6, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      let fecha = this.$route.params.data_edit.fecha_hora_inicio_servicio;

      if (hoy < fecha) {
        this.disabledf = true;
      } else {
        this.disabledf = false;
      }
    },

    cargarCeco() {
      this.cecosAfes.push({
        id: null,
        sociedad_presupuesto_id: this.formCeAf.sociedad_presupuesto_id,
        activo_id: this.formCeAf.activo_id,
        cecos_afe_id: this.formCeAf.cecos_afe_id,
        responsable_id: this.formCeAf.responsable_id,
        nombre_responsable: this.formCeAf.nombre_responsable,
        tipo_presupuesto: this.formCeAf.tipo_presupuesto,
        nTipoPresupuesto:
          this.formCeAf.tipo_presupuesto == 1 ? "Orden Interna" : "PEP",
        porcentaje: this.formCeAf.porcentaje,
        numero: this.formCeAf.numero,
        ...this.etiquetasCecoSociedadActivo(this.formCeAf),
      });
      this.porcentajeTotal();
      this.limpiarMaestrosCecoTrasCargar();
    },

    limpiarMaestrosCecoTrasCargar() {
      /* Solo el bloque Ceco/Afe de alta: país, bloque, área y sitio quedan en el formulario (padres). */
      this.listasForms.sociedades = [];
      this.listasForms.activos = [];
      this.listasForms.tipo_presupuesto = [];
      this.listasForms.lst_numero = [];
      this.formCeAf.sociedad_presupuesto_id = null;
      this.formCeAf.activo_id = null;
      this.formCeAf.tipo_presupuesto = null;
      this.formCeAf.responsable_id = null;
      this.formCeAf.nombre_responsable = null;
      this.formCeAf.porcentaje = null;
      this.formCeAf.cecos_afe_id = null;
      this.formCeAf.numero = null;
      this.tipo_presupuesto = {};
      this.cecos = {};
      this.responsable = null;
      this.getNumeroContable();
    },

    verFormActualizarCecoAfe(cecosAfes_id) {
      const row = this.cecosAfes[cecosAfes_id];
      this.idActualizarCA = cecosAfes_id;

      const tipoNum =
        row.tipo_presupuesto && row.tipo_presupuesto.numeracion != null
          ? row.tipo_presupuesto.numeracion
          : row.tipo_presupuesto;

      const segmentarRows = this.cecosAfes.map((r) => ({
        sociedad_presupuesto_id: r.sociedad_presupuesto_id,
        activo_id: r.activo_id,
        tipo_presupuesto:
          r.tipo_presupuesto && r.tipo_presupuesto.numeracion != null
            ? r.tipo_presupuesto.numeracion
            : r.tipo_presupuesto,
        bloque_id: this.form.bloque_id,
        area: this.form.area,
        sitio_id: this.form.sitio_id,
      }));
      this.segmentarCecosAfes(segmentarRows);

      this.tipo_presupuesto2 = {};
      this.cecos2 = {};
      this.responsable2 = {};

      this.formCeAf2 = {
        id: row.id,
        sociedad_presupuesto_id: row.sociedad_presupuesto_id,
        activo_id: row.activo_id,
        cecos_afe_id: row.cecos_afe_id,
        responsable_id: row.responsable_id,
        nombre_responsable: row.nombre_responsable,
        tipo_presupuesto: tipoNum,
        porcentaje: row.porcentaje,
        numero:
          row.numero && typeof row.numero === "object"
            ? row.numero.codigo_contable
            : row.numero,
        ...this.etiquetasCecoSociedadActivo({
          sociedad_presupuesto_id: row.sociedad_presupuesto_id,
          activo_id: row.activo_id,
        }),
      };

      const tipoObj = (this.listasForms.tipo_presupuesto || []).find(
        (t) => t.numeracion == tipoNum,
      );
      if (tipoObj) {
        this.tipo_presupuesto2 = tipoObj;
      }

      if (row.responsable && row.responsable.id) {
        const r = row.responsable;
        const nom =
          r.nombres && r.apellidos
            ? `${r.nombres} ${r.apellidos}`.trim()
            : r.nombres || "";
        this.responsable2 = {
          id: r.id,
          nombres: nom,
          user_id: r.user_id,
        };
      } else if (row.responsable_id && row.nombre_responsable) {
        this.responsable2 = {
          id: row.responsable_id,
          nombres: row.nombre_responsable,
        };
      }

      this.formActualizarCA = true;

      this.getNumeroContable2(() => this.syncCeco2SeleccionDesdeFila(row));
      this.getResponsable2();
    },

    syncCeco2SeleccionDesdeFila(row) {
      const lista = this.listasForms2.lst_numero || [];
      if (!lista.length) {
        return;
      }
      const id = row.cecos_afe_id;
      let found = null;
      if (id) {
        found = lista.find((x) => x.id === id);
      }
      if (
        !found &&
        row.numero &&
        typeof row.numero === "object" &&
        row.numero.id
      ) {
        found = lista.find((x) => x.id === row.numero.id);
      }
      if (!found && this.formCeAf2.numero) {
        found = lista.find((x) => x.codigo_contable == this.formCeAf2.numero);
      }
      if (found) {
        this.cecos2 = found;
        if (!this.formCeAf2.cecos_afe_id) {
          this.formCeAf2.cecos_afe_id = found.id;
        }
        if (!this.formCeAf2.numero) {
          this.formCeAf2.numero = found.codigo_contable;
        }
      }
    },

    syncResponsable2EnLista() {
      if (!this.responsable2 || !this.responsable2.id) {
        return;
      }
      const lista = this.listasForms2.respon || [];
      const m = lista.find((x) => x.id === this.responsable2.id);
      if (m) {
        this.responsable2 = m;
      }
    },

    selectTipoPresupuesto2() {
      this.formCeAf2.tipo_presupuesto = null;
      if (this.tipo_presupuesto2 && this.tipo_presupuesto2.numeracion != null) {
        this.formCeAf2.tipo_presupuesto = this.tipo_presupuesto2.numeracion;
      }
      if (this.formCeAf2.tipo_presupuesto) {
        if (
          this.cecos2 &&
          this.cecos2.tipo_presupuesto != null &&
          this.cecos2.tipo_presupuesto != this.formCeAf2.tipo_presupuesto
        ) {
          this.cecos2 = {};
          this.responsable2 = {};
          this.formCeAf2.cecos_afe_id = null;
          this.formCeAf2.numero = null;
          this.formCeAf2.responsable_id = null;
          this.formCeAf2.nombre_responsable = null;
        }
        this.getNumeroContable2();
      } else {
        this.listasForms2.lst_numero = [];
        this.listasForms2.respon = [];
        this.cecos2 = {};
        this.responsable2 = {};
        this.formCeAf2.cecos_afe_id = null;
        this.formCeAf2.numero = null;
        this.formCeAf2.responsable_id = null;
        this.formCeAf2.nombre_responsable = null;
      }
    },

    onMaestroCecoCampoChangeEdit(campo) {
      if (campo === "sociedad") {
        this.formCeAf2.activo_id = null;
        this.formCeAf2.tipo_presupuesto = null;
        this.tipo_presupuesto2 = {};
        this.cecos2 = {};
        this.responsable2 = {};
        this.formCeAf2.cecos_afe_id = null;
        this.formCeAf2.numero = null;
        this.formCeAf2.responsable_id = null;
        this.formCeAf2.nombre_responsable = null;
        this.listasForms2.lst_numero = [];
        this.listasForms2.respon = [];
        return;
      }
      if (campo === "activo") {
        this.formCeAf2.tipo_presupuesto = null;
        this.tipo_presupuesto2 = {};
        this.cecos2 = {};
        this.responsable2 = {};
        this.formCeAf2.cecos_afe_id = null;
        this.formCeAf2.numero = null;
        this.formCeAf2.responsable_id = null;
        this.formCeAf2.nombre_responsable = null;
        this.listasForms2.lst_numero = [];
        this.listasForms2.respon = [];
      }
    },

    getNumeroContable2(alCargar) {
      const filtros = {
        area: this.form.area ? this.form.area : null,
        sitio_id: this.form.sitio_id ? this.form.sitio_id : null,
        bloque_id: this.form.bloque_id ? this.form.bloque_id : null,
        pais_id: this.form.pais_id ? this.form.pais_id : null,
        tipo_presupuesto: this.formCeAf2.tipo_presupuesto
          ? this.formCeAf2.tipo_presupuesto
          : null,
        activo_id: this.formCeAf2.activo_id ? this.formCeAf2.activo_id : null,
        sociedad_presupuesto_id: this.formCeAf2.sociedad_presupuesto_id
          ? this.formCeAf2.sociedad_presupuesto_id
          : null,
      };
      axios
        .get("/api/admin/cecosYafes/lista", {
          params: filtros,
        })
        .then((response) => {
          const data = this.normalizarListaCecosYafes(response.data);
          this.listasForms2.lst_numero = data;
          if (typeof alCargar === "function") {
            alCargar(data);
          }
        });
    },

    selectNumeroContable2() {
      this.formCeAf2.cecos_afe_id = null;
      this.formCeAf2.numero = null;
      if (this.cecos2 && this.cecos2.id) {
        this.formCeAf2.cecos_afe_id = this.cecos2.id;
        this.formCeAf2.numero = this.cecos2.codigo_contable;
      }
      this.formCeAf2.responsable_id = null;
      this.formCeAf2.nombre_responsable = null;
      this.responsable2 = {};
    },

    getSelectResponsable2() {
      this.formCeAf2.responsable_id = null;
      this.formCeAf2.nombre_responsable = null;
      if (this.responsable2 && this.responsable2.id) {
        this.formCeAf2.responsable_id = this.responsable2.id;
        this.formCeAf2.nombre_responsable = this.responsable2.nombres;
      }
    },

    getResponsable2(alCargar) {
      axios
        .get("/api/admin/funcionarios/lista", {
          params: { con_usuario: 1 },
        })
        .then((response) => {
          this.listasForms2.respon = response.data || [];
          this.syncResponsable2EnLista();
          if (typeof alCargar === "function") {
            alCargar(response.data);
          }
        });
    },

    guardarActualizacionCecoAfe(cecosAfes_id) {
      // Se valida el valor del porcentaje
      let flag_porcentaje = this.total_porcentaje;
      flag_porcentaje -= Number(this.cecosAfes[cecosAfes_id].porcentaje);
      flag_porcentaje += Number(this.formCeAf2.porcentaje);

      if (flag_porcentaje > 100) {
        this.$swal({
          title: "Excedió la cantidad de ceco y afe permitida",
          text: `El límite del porcentaje es 100% de Ceco o Afe, por favor validar..`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2000,
          backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
        });
        flag_porcentaje -= Number(this.formCeAf2.porcentaje);
        this.formCeAf2.porcentaje = this.cecosAfes[cecosAfes_id].porcentaje;
        flag_porcentaje += Number(this.formCeAf2.porcentaje);
      } else {
        const fila = this.cecosAfes[cecosAfes_id];

        this.formActualizarCA = false;

        fila.responsable_id = this.formCeAf2.responsable_id;
        fila.nombre_responsable = this.formCeAf2.nombre_responsable;
        if (this.responsable2 && this.responsable2.id) {
          fila.responsable = this.responsable2;
        }

        if (
          this.tipo_presupuesto2 &&
          this.tipo_presupuesto2.numeracion != null
        ) {
          fila.tipo_presupuesto = { ...this.tipo_presupuesto2 };
          fila.nTipoPresupuesto =
            this.tipo_presupuesto2.descripcion ||
            (this.formCeAf2.tipo_presupuesto == 1 ? "Orden Interna" : "PEP");
        } else {
          fila.tipo_presupuesto = this.formCeAf2.tipo_presupuesto;
          fila.nTipoPresupuesto =
            this.formCeAf2.tipo_presupuesto == 1 ? "Orden Interna" : "PEP";
        }

        fila.porcentaje = this.formCeAf2.porcentaje;
        fila.numero = this.formCeAf2.numero;
        fila.cecos_afe_id = this.formCeAf2.cecos_afe_id;
        fila.sociedad_presupuesto_id = this.formCeAf2.sociedad_presupuesto_id;
        fila.activo_id = this.formCeAf2.activo_id;

        Object.assign(fila, this.etiquetasCecoSociedadActivo(this.formCeAf2));

        this.$set(this.cecosAfes, cecosAfes_id, { ...fila });
      }
      // Se actualiza el valor del porcentaje
      this.total_porcentaje = flag_porcentaje;
    },

    borrarCecoAfe(cecosAfes_id) {
      this.$swal({
        title: "Está seguro de quitar el Ceco o Afe?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Quitar!",
      }).then((result) => {
        if (result.value) {
          this.total_porcentaje -= this.cecosAfes[cecosAfes_id].porcentaje;
          // Borramos de la lista
          this.cecosAfes.splice(cecosAfes_id, 1);
        }
      });
    },

    async datos() {
      await axios.get("/api/funcionariosFrontera/getUser").then((response) => {
        this.user = response.data[0];
        this.formPa.user_id = this.user.id;
        this.formPa.nombre = this.user.name;
        this.formPa.numero_documento = this.user.n_document;
        this.formPa.telefono = this.user.cel;
        this.formPa.correo = this.user.email;
        this.formPa.empresa = "GEO-PARK";
      });
    },

    /* descargarFormatoPasajeros() {
      window.open(
        process.env.VUE_APP_API_URL + "/exports/formatoTepListaPasajeros.xlsx",
        "_blank"
      );
    },
 */

    descargarFormatoPasajeros() {
      this.cargando = true;
      axios({
        method: "get",
        url: "/api/funcionariosFrontera/solicitudNacional/exportPlantilla",
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    obtenerFile(e) {
      this.fileFormat = null;
      if (e.target.files[0]) {
        this.cargando = true;
        const file = e.target.files[0];
        if (this.validaArchivo(file)) {
          this.fileFormat = file;
        }
        this.cargando = false;
      }
    },

    validaArchivo(file) {
      let flag = true;
      if (file.size > 2048000) {
        flag = false;
        this.fileFormat = null;
        this.cargando = false;
        this.$swal({
          icon: "error",
          title: `El Archivo es muy pesado para subirlo`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      return flag;
    },

    quitarLista() {
      this.fileFormat = null;
      this.$refs.file_format.value = null;
    },

    cargarPasajaeros() {
      this.cargando = true;
      let me = this;
      let formData = new FormData();
      formData.append("file_formato", this.fileFormat);
      formData.append(
        "pasajeros_vehiculo",
        this.form.tipo_vehiculo.cantidad_pasajeros,
      );
      formData.append("pasajeros_actuales", this.pasajeros.length);
      axios
        .post(
          "/api/funcionariosFrontera/solicitudNacional/cargarPasajeros",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          if (!response.data.error) {
            Object.assign(this.pasajeros, response.data.resultado_archivo);
            me.$swal({
              icon: "success",
              title: "Los datos se guardaron exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            let content_error = "<h4>Errores encontrados.</h4>";
            response.data.error.forEach(
              (err) => (content_error += `<div><small>${err}</small></div>`),
            );
            this.$swal({
              title: "Error en el contenido del archivo",
              html: content_error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000 + 900 * response.data.error.length,
              backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
            });
          }
          this.quitarLista();
          me.cargando = false;
        })
        .catch(function(error) {
          me.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    cargarPasajero() {
      // Se agrega a nuestra lista
      if (this.form.tipo_vehiculo) {
        this.pasajeros.push({
          id: +new Date(),
          nombres: this.formPa.nombre,
          numero_documento: this.formPa.numero_documento,
          correo: this.formPa.correo,
          telefono: this.formPa.telefono,
          empresa: this.formPa.empresa,
          funcionario_id: this.formPa.funcionario_id,
        });
        this.cantPasajeros();
        // Vaciamos el formulario de añadir
        this.formPa.nombre = "";
        this.formPa.numero_documento = "";
        this.formPa.correo = "";
        this.formPa.telefono = "";
        this.formPa.empresa = "";
      } else {
        this.$swal({
          icon: "error",
          title: "Debe seleccionar primero el tipo de vehículo",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    verFormActualizarPa(pasajeros_id) {
      // Antes de mostrar el formulario de actualizar, rellenamos sus campos
      this.idActualizarPa = pasajeros_id;
      this.formPa2.nombre = this.pasajeros[pasajeros_id].nombres;
      this.formPa2.numero_documento = this.pasajeros[
        pasajeros_id
      ].numero_documento;
      this.formPa2.telefono = this.pasajeros[pasajeros_id].telefono;
      this.formPa2.correo = this.pasajeros[pasajeros_id].correo;
      this.formPa2.empresa = this.pasajeros[pasajeros_id].empresa;
      // Mostramos el formulario
      this.formActualizarPa = true;
    },

    guardarActualizacionPa(pasajeros_id) {
      // Ocultamos nuestro formulario de actualizar
      this.formActualizarPa = false;
      // Actualizamos los datos
      this.pasajeros[pasajeros_id].nombres = this.formPa2.nombre;
      this.pasajeros[
        pasajeros_id
      ].numero_documento = this.formPa2.numero_documento;
      this.pasajeros[pasajeros_id].telefono = this.formPa2.telefono;
      this.pasajeros[pasajeros_id].correo = this.formPa2.correo;
      this.pasajeros[pasajeros_id].empresa = this.formPa2.empresa;
      this.pasajeros[pasajeros_id].funcionario_id = this.formPa2.funcionario_id;
    },

    borrarPasajero(pasajeros_id) {
      this.$swal({
        title: "Está seguro de quitar el pasajero?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Quitar!",
      }).then((result) => {
        if (result.value) {
          // Borramos de la lista
          this.pasajeros.splice(pasajeros_id, 1);
        }
      });
    },

    async save() {
      let datos = {
        id: this.form.id,
        user_id: this.user.id,
        area: this.form.area,
        bloque_id: this.form.bloque_id,
        pais_id: this.form.pais_id,
        sitio_id: this.form.sitio_id,
        ruta_id: this.form.ruta_id,
        tipo_vehiculo: this.form.tipo_vehiculo.id,
        fecha_hora_inicio_servicio:
          this.form.fecha_ini + " " + this.form.hora_ini,
        fecha_hora_fin_servicio: this.form.fecha_fin + " " + this.form.hora_fin,
        gerente_area: this.form.gerente_area.id,
        gerente_area_user: this.form.gerente_area.user_id,
        direccionOrigen: this.form.direccionOrigen,
        direccionDestino: this.form.direccionDestino,
        cant_pasajeros: this.pasajeros.length,
        pasajero: this.pasajeros,
        cecosAfes: this.cecosAfesConPadresParaApi(),
        metodo: this.metodo,
        motivo: this.form.motivo,
        ruta_nombre: this.form.ruta_nombre,
        tipo: "Web",
      };

      if (!this.$v.form.$invalid) {
        this.cargando = true;
        await axios({
          method: this.metodo,
          url: "/api/funcionariosFrontera/solicitudNacional",
          data: datos,
        })
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se actualizó la solicitud exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
            this.back();
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.back();
          });
      }
    },

    selectTipoPresupuesto() {
      if (!this.tipo_presupuesto || this.tipo_presupuesto.numeracion == null) {
        this.formCeAf.tipo_presupuesto = null;
        this.limpiarDesdeNivelMaestroCeco("tipo_presupuesto");
        return;
      }
      this.formCeAf.tipo_presupuesto = this.tipo_presupuesto.numeracion;
      this.limpiarDesdeNivelMaestroCeco("bloque");
    },

    selectSitio() {
      this.form.sitio_id = null;
      if (!this.sitio || !this.sitio.id) {
        this.limpiarDesdeNivelMaestroCeco("sitio");
        return;
      }
      this.form.sitio_id = this.sitio.id;
      this.getNumeroContable();
    },

    selectNumeroContable() {
      this.formCeAf.cecos_afe_id = null;
      this.formCeAf.numero = null;
      this.formCeAf.responsable_id = null;
      this.formCeAf.nombre_responsable = null;
      this.responsable = null;
      if (this.cecos && this.cecos.id) {
        this.formCeAf.cecos_afe_id = this.cecos.id;
        this.formCeAf.numero = this.cecos.codigo_contable;
      }
    },

    getSelectResponsable() {
      this.formCeAf.responsable_id = null;
      if (this.responsable) {
        this.formCeAf.responsable_id = this.responsable.id;
        this.formCeAf.nombre_responsable = this.responsable.nombres;
      }
    },
  },
  async mounted() {
    await this.getTipoPresupuesto();
    await this.getTipoVehiculo();
    await this.getGerente();
    await this.getPaises();
    await this.getAreas();
    await this.getSitios();
    await this.getSociedades();
    await this.getActivos();
    await this.getResponsable();
    await this.init();
  },
};
</script>
